import { i18n as _i18n } from "@lingui/core";
import { CarleadCreationButton, CarleadCreationForm, CarleadLicensePlateNotRecognized, CarleadMileageFormatted, defaultCarleadSplitFlow, PricedCarsCounter, QuestionnaireSelect, renderFieldVerticalWrapper, SplitBodyTypes, SplitBuiltDates, SplitDoorCount, SplitFuelType, SplitGearType, SplitHorsePower, SplitMainTypeDetails, SplitMainTypes, SplitMainTypesSub, SplitManufacturers, useCreateCarleadChainedRequest, useCreateConsumerCarleadRequestChain, useCreateNormalCarleadForm, useFormQuestionnaireProps, useSplitFieldsFlowService, useSplitFieldsProps } from '@wkda/carlead-creation-components';
import cx from 'classnames';
import { Paper } from '@wkda/styleguide';
import { useTrackLanding } from '@wkda/funnel-components';
import { CarleadProgress, ReturningCustomerPopup, TrustPilot, TermsAndConditions, CarleadEmailFieldWithTracking } from '../../../../../components';
import { useMinimumMileageValidation, useMileageThresholdException } from '../../../../../hooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadStepCompoundCustomerPopupCustomerCounter = ({
  wide = false,
  className = '',
  showTerms = false,
  emailSubtitle = false,
  emailInfoMessage = false
}) => {
  const mileageProps = useMinimumMileageValidation();
  const {
    upperThreshold,
    lowerThreshold
  } = useMileageThresholdException();
  const questionnaireProps = useFormQuestionnaireProps(defaultCarleadSplitFlow);
  const splitFieldsProps = useSplitFieldsProps();
  const machine = useSplitFieldsFlowService(defaultCarleadSplitFlow);
  const request = useCreateCarleadChainedRequest([
  // make this the last one
  useCreateConsumerCarleadRequestChain()]);
  const consumerForm = useCreateNormalCarleadForm([questionnaireProps, splitFieldsProps, mileageProps]);
  useTrackLanding();
  return /*#__PURE__*/_jsxs(Paper, {
    className: "carlead-creation-form__container step-compound",
    children: [/*#__PURE__*/_jsx(ReturningCustomerPopup, {}), /*#__PURE__*/_jsx("div", {
      className: `box gap full-height ${className}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: cx('container', {
          'container-xl': wide
        }),
        children: [/*#__PURE__*/_jsx(CarleadLicensePlateNotRecognized, {}), /*#__PURE__*/_jsx(PricedCarsCounter, {}), /*#__PURE__*/_jsxs(CarleadCreationForm, {
          carleadForm: consumerForm,
          options: {
            name: 'StepCompound'
          },
          machineService: machine,
          submitHandler: request,
          children: [/*#__PURE__*/_jsx(SplitManufacturers, {}), /*#__PURE__*/_jsx(SplitMainTypes, {}), /*#__PURE__*/_jsx(SplitBuiltDates, {}), /*#__PURE__*/_jsx(SplitBodyTypes, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitFuelType, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitMainTypeDetails, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitHorsePower, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitGearType, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitDoorCount, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitMainTypesSub, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(CarleadMileageFormatted, {
            lowerThreshold: lowerThreshold,
            upperThreshold: upperThreshold,
            suspiciousMileageMessageDelay: 2000,
            isHiddenField: true,
            renderFieldWrapper: renderFieldVerticalWrapper
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELLPOINT",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellpoint'
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNow'
              }),
              value: 'SELLPOINT_NOW'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint4weeks'
              }),
              value: 'SELLPOINT_4_WEEKS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint3months'
              }),
              value: 'SELLPOINT_3_MONTHS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNotPlanned'
              }),
              value: 'SELLPOINT_NOT_PLANNED'
            }]
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELL_TYPES",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellTypes'
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesPrivate'
              }),
              value: 'PRIVATE'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesDealer'
              }),
              value: 'DEALER'
            }]
          }), /*#__PURE__*/_jsx(CarleadEmailFieldWithTracking, {
            subtitle: emailSubtitle,
            emailInfoMessage: emailInfoMessage
          }), /*#__PURE__*/_jsx(CarleadProgress, {}), /*#__PURE__*/_jsx(CarleadCreationButton, {}), showTerms && /*#__PURE__*/_jsx(TermsAndConditions, {})]
        }), showTerms && /*#__PURE__*/_jsx("div", {
          className: "conditions-text__container"
        }), /*#__PURE__*/_jsxs("section", {
          className: "trust-box",
          children: [/*#__PURE__*/_jsx("div", {
            className: "d-none d-lg-block",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "desktop"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "d-block d-lg-none",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "mobile"
            })
          })]
        })]
      })
    })]
  });
};
export default CarleadStepCompoundCustomerPopupCustomerCounter;